import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { KpiGrid } from "@/components/kcc/Kpi";
import { Panel, ModuleHeader } from "@/components/kcc/Panel";
import { DataTable } from "@/components/kcc/DataTable";
import { KccBarChart } from "@/components/kcc/Charts";

export default function MineIntelligence() {
    const [data, setData] = useState(null);
    useEffect(() => { api.get("/mining/intelligence").then(({ data }) => setData(data)); }, []);
    const pareto = (data?.delay_pareto || []).map((p) => ({ name: p.code, value: p.minutes, reason: p.reason }));

    return (
        <div className="space-y-6">
            <ModuleHeader
                kicker="Mine Operations Intelligence"
                title="Shift, Delay & Operator Performance"
                description="Dispatch intelligence, delay-code Pareto, cycle-time analysis, operator performance benchmarking and 14-day production reconciliation."
            />
            <KpiGrid kpis={data?.kpis || []} accent="copper" cols={4} />

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                <Panel title="Delay Pareto (minutes lost, 14d)" accent="amber">
                    <KccBarChart data={pareto} dataKey="value" label="Minutes" color="#f59e0b" />
                </Panel>
                <Panel title="Operator Performance" subtitle="Top 20 by utilisation" accent="copper">
                    <DataTable
                        columns={[
                            { key: "operator", label: "Operator" },
                            { key: "units", label: "Units assigned" },
                            { key: "avg_util", label: "Utilisation", render: (r) => `${r.avg_util}%` },
                            { key: "avg_avail", label: "Availability", render: (r) => `${r.avg_avail}%` },
                        ]}
                        rows={data?.operator_performance || []}
                        testid="operator-performance"
                    />
                </Panel>
            </div>

            <Panel title="Delay Events (14 days)" accent="amber">
                <DataTable
                    columns={[
                        { key: "date", label: "Date", render: (r) => r.date.slice(0, 10) },
                        { key: "shift", label: "Shift" },
                        { key: "code", label: "Code" },
                        { key: "reason", label: "Reason" },
                        { key: "area", label: "Area" },
                        { key: "duration_min", label: "Duration (min)" },
                        { key: "impact_t_lost", label: "Lost (t)", render: (r) => r.impact_t_lost.toLocaleString() },
                    ]}
                    rows={data?.delays || []}
                    testid="delays-table"
                />
            </Panel>
        </div>
    );
}
